import React from 'react';
import { socialIconMap, socialBrandColors } from '../shared/icons';

const SocialFollows = ({ theme, social }) => {
  const validLinks = Object.entries(social).filter(([, url]) => url?.trim());
  if (!validLinks.length) return null;

  return (
    <section style={{
      backgroundColor: theme.colors.background,
      borderRadius: theme.borderRadius.lg,
      boxShadow: theme.shadows.md,
      padding: '40px',
      marginBottom: '40px',
      textAlign: 'center'
    }}>
      <h2 style={{
        fontFamily: theme.fonts.heading, color: theme.colors.heading,
        fontSize: '2rem', margin: '0 0 30px 0'
      }}>
        Follow Us
      </h2>
      <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
        {validLinks.map(([platform, url]) => {
          const SocialIcon = socialIconMap[platform.toLowerCase()];
          const brandColor = socialBrandColors[platform.toLowerCase()];
          const isSnapchat = platform.toLowerCase() === 'snapchat';
          return (
            <a
              key={platform}
              data-field={platform}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              title={`Follow us on ${platform}`}
              style={{
                backgroundColor: brandColor || theme.colors.primary,
                color: isSnapchat ? '#000000' : '#ffffff',
                width: '50px', height: '50px', borderRadius: '50%',
                textDecoration: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                transition: 'all 0.2s ease', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                border: isSnapchat ? '2px solid #000000' : 'none'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px) scale(1.1)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.25)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
              }}
            >
              {SocialIcon && <SocialIcon size={24} />}
            </a>
          );
        })}
      </div>
    </section>
  );
};

export default SocialFollows;
